import { Modal, Platform } from "react-native";
import ModalAtom from "@components/atoms/Modal";
import { SpaceType } from "@components/atoms/Spacer/types";
import CustomWeb from "@components/atoms/Webview";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled, { css, useTheme } from "styled-components/native";
import { VDBIcons } from "@utils/VDBIcons";
import React from "react";
import { screenHeight } from "@utils/constants";
import { HyperLinkModalProp } from "./utils";

const HyperLinkModal = ({
  isOpen,
  onClose,
  preview_link,
  mTitle,
}: HyperLinkModalProp) => {
  const theme = useTheme();
  const { t } = useTranslation();

  let isSmallDeviceWidth = !theme.isMobile ? true : false;
  let extraSmallImage = false;

  const imageComponent = useMemo(() => {
    return (
      <CustomWeb
        isSmallDeviceWidth={isSmallDeviceWidth}
        url={preview_link}
        extraSmallImage={extraSmallImage}
        showLoader={true}
      />
    );
  }, [preview_link]);

  return (
    <>
      {Platform.OS === "web" && theme.isLargeScreen ? (
        <Modal
          animationType="slide"
          transparent={true}
          visible={isOpen}
          supportedOrientations={["landscape", "portrait"]}
        >
          <CenteredView>
            <ModalView>
              <ClosedView onPress={onClose}>
                <ClosedContainerView>
                  <VDBIcon
                    name={VDBIcons.CLOSE_CIRCLE}
                    size={24}
                    color={theme["core-06"]}
                    variant={IconsVariant.VDBCustom}
                  />
                </ClosedContainerView>
              </ClosedView>
              <Container>
                <MainContainer>{imageComponent}</MainContainer>
              </Container>
            </ModalView>
          </CenteredView>
        </Modal>
      ) : (
        <ModalAtom
          headerTitle={t(
            mTitle ? mTitle : "productDetailPage.previewScreen.title.text"
          )}
          isOpen={isOpen}
          onClose={onClose}
          paddingBottom={0}
          paddingLeft={0}
          paddingTop={0}
          paddingRight={0}
          size="lg"
          enableToastMessage={true}
          allowFullScreen={theme.isTablet ? true : false}
        >
          <Container>
            <MainContainer height={screenHeight * 0.75}>
              {imageComponent}
            </MainContainer>
          </Container>
        </ModalAtom>
      )}
    </>
  );
};

const MainContainer = styled.View<any>`
  height: ${({ height }) => (height ? `${height}px` : "100%")};
  width: 100%;
  background-color: "transparent";
`;

const Container = styled.View`
  flex: 1;
  flex-basis: auto;
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      justify-content: center;
      align-items: center;
    `}
  ${({ theme }) =>
    theme.isMobile && Platform.OS !== "web"
      ? css`
          padding-top: 24px;
        `
      : css`
          padding-right: 0px;
        `};
`;

const CenteredView = styled.View<any>`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme["core-01"]};
  height: 100%;
`;

const ModalView = styled.View`
  border-radius: 22px;
  width: 100%;
  height: 100%;
`;

const ClosedView = styled.TouchableOpacity`
  top: 0;
  position: absolute;
  right: 0;
  z-index: 1;
`;

const ClosedContainerView = styled.View`
  padding: ${SpaceType.Extra}px;
`;

export default HyperLinkModal;
